//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Prism from 'prismjs';
/* eslint-disable no-unused-vars */
// prism plugins install on import.
import PrismApache from 'prismjs/components/prism-apacheconf';
import PrismBase from 'prismjs/components/prism-bash';
import PrismJson from 'prismjs/components/prism-json';
import PrismPython from 'prismjs/components/prism-python';
import PrismSql from 'prismjs/components/prism-sql';
import PrismNormaliseWhitespace from 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
/* eslint-enable */

export default {
  name: 'DpCodeBlock',
  props: {
    lang: { type: String, required: true },
    body: { type: String, required: false, default: null },
    noCopy: { type: Boolean, required: false, default: false },
    isLog: { type: Boolean, required: false, default: false },
    isOdd: { type: Boolean, required: false, default: true },
    isPlaceholder: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    scrollPosition: { type: Object, default: () => ({ left: 0, top: 0 }) },
  },
  data() {
    return {
      text: null,
      copied: false,
    };
  },
  computed: {
    parsedCode() {
      if (!this.text && !this.$slots.default && !this.body) {
        return null;
      }

      const text = this.body || this.text || this.$slots.default[0].text;
      const code = Prism.plugins.NormalizeWhitespace.normalize(text);
      const prismLang = Prism.languages[this.lang];
      return Prism.highlight(code, prismLang);
    },
    languageClass() {
      if (!this.lang) {
        return 'code-block language-none';
      }
      return `code-block language-${this.lang}`;
    },
    copyToClipboardText() {
      return this.copied ? 'Copied to clipboard' : 'Copy to clipboard';
    },
  },
  watch: {
    scrollPosition: {
      handler(position) {
        this.scrollTo(position);
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.highlight();
    });
  },
  methods: {
    highlight() {
      if (!this.$slots.default) {
        return;
      }

      this.text = this.$slots.default[0].text;
    },
    copyToClipboard() {
      let code = this.body;

      if (!this.body && (!this.$slots.default[0] || !this.$slots.default[0].text)) {
        return;
      }

      if (!this.body) {
        code = this.$slots.default[0].text.trim();
      }

      // Avoid throwing errors during tests
      if (document.execCommand) {
        const el = document.createElement('textarea');
        el.value = code;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }

      this.copied = true;

      // Reset the state after a delay
      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
    scrollTo({ left = null, top = null } = {}) {
      window.requestAnimationFrame(() => {
        if (left !== null) {
          this.$refs.codeContainer.scrollLeft = left;
        }
        if (top !== null) {
          this.$refs.codeContainer.scrollTop = top;
        }
      });
    },
  },
};
